export default [
    {
        path: 'origem-programatica',
        component: () => import(/* webpackChunkName: 'cadastro-origem-programatica' */ '@/views/cadastro/origem-programatica/Index'),
        redirect: 'origem-programatica/index',
        children: [
            {
                name: 'cadastro-origem-programatica-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-origem-programatica' */ '@/views/cadastro/origem-programatica/List.vue'),
            },
            {
                name: 'cadastro-origem-programatica-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-origem-programatica' */ '@/views/cadastro/origem-programatica/Form.vue'),
            },
            {
                name: 'cadastro-origem-programatica-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'cadastro-origem-programatica' */ '@/views/cadastro/origem-programatica/Form.vue'),
            },
        ],
    },
]